import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Contact = () => {
  const contactInfo = [
    {
      icon: <FaPhone />,
      title: 'Telepon',
      info: '+62 812-9721-8055',
      link: 'tel:+6281297218055'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      info: 'sales@orionbilling.com',
      link: 'mailto:sales@orionbilling.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Alamat',
      info: 'Batam, Indonesia',
      link: '#'
    }
  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-label">HUBUNGI KAMI</span>
          <h2 className="section-title">Siap Mencoba Orion Billing?</h2>
          <p className="section-description">
            Dapatkan free trial 14 hari atau request demo untuk melihat bagaimana Orion dapat membantu bisnis Anda
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Orion Billing System</h3>
            <p className="company-tagline">
              Smart billing solution untuk bisnis modern
            </p>

            <div className="contact-details">
              {contactInfo.map((item, index) => (
                <a key={index} href={item.link} className="contact-item">
                  <div className="contact-icon">{item.icon}</div>
                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.info}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="social-links">
              <h4>Ikuti Kami</h4>
              <div className="social-icons">
                <a href="https://wa.me/6281234567890" target="_blank" rel="noopener noreferrer" className="social-icon"><FaWhatsapp /></a>
                <a href="https://www.linkedin.com/company/cvorion" target="_blank" rel="noopener noreferrer" className="social-icon"><FaLinkedin /></a>
                <a href="https://www.instagram.com/cvorion" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <form>
              <div className="form-row">
                <div className="form-group">
                  <label>Nama Lengkap</label>
                  <input type="text" placeholder="Masukkan nama Anda" required />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" placeholder="Masukkan email Anda" required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Telepon</label>
                  <input type="tel" placeholder="Masukkan nomor telepon" required />
                </div>
                <div className="form-group">
                  <label>Perusahaan</label>
                  <input type="text" placeholder="Nama perusahaan" />
                </div>
              </div>
              <div className="form-group">
                <label>Subjek</label>
                <select required>
                  <option value="">Pilih jenis pertanyaan</option>
                  <option value="trial">Request Free Trial</option>
                  <option value="demo">Request Demo</option>
                  <option value="pricing">Pricing Information</option>
                  <option value="support">Technical Support</option>
                  <option value="other">Lainnya</option>
                </select>
              </div>
              <div className="form-group">
                <label>Pesan</label>
                <textarea rows="5" placeholder="Ceritakan kebutuhan Anda..." required></textarea>
              </div>
              <button type="submit" className="btn-primary btn-submit">
                Request Free Trial
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
